import { render, staticRenderFns } from "./MyReportList.vue?vue&type=template&id=08aa8d1b&"
import script from "./MyReportList.vue?vue&type=script&lang=js&"
export * from "./MyReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports